import { isSuburban } from './category/isSuburban';
import { getOrder } from './getOrder';
import { getUnderground } from './getUnderground';

import type { IJsonQueryRailway } from 'shared/json_query';
import type { IOffer, IRailway } from 'shared/offer';

/**
 * Берем Ж/Д из гео офера geo.railways
 * выводим первый элемент из списка, отсортировав в соответствии с geo.sortedGeoIds
 */
export const railway = (offer: IOffer): IRailway | undefined => {
  const metro = getUnderground(offer);
  const railways = offer.geo?.railways || [];
  const sortedGeoIds = offer.geo?.sortedGeoIds || [];

  const railwaysOrderMap: Map<number, number> = (
    sortedGeoIds.filter(item => item.type === 'railway') as IJsonQueryRailway[]
  ).reduce((map, item, index) => {
    map.set(item.id, index);

    return map;
  }, new Map<number, number>());

  /**
   * Сортируем согласно порядку полученному из geo.sortedGeoId
   * станции, по каким то причинам, не попавшие в geo.sortedGeoId, идут низшим приоритетом
   */
  const offerRailways = railways
    .concat()
    .sort((a, b) => getOrder(railwaysOrderMap, a.id, Infinity) - getOrder(railwaysOrderMap, b.id, Infinity));

  return isSuburban(offer) || !metro ? offerRailways[0] : undefined;
};
